import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }

import DeleteOutlined from '@ant-design/icons-vue/DeleteOutlined';
import RollbackOutlined from '@ant-design/icons-vue/RollbackOutlined';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteRestoreAssignmentButton',
  props: {
    disabled: { type: Boolean },
    assignment: null
  },
  emits: ["remove-click", "restore-click"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'remove-click', assignment: Record<string, any>): void;
    (e: 'restore-click', assignment: Record<string, any>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    disabled: boolean;
    assignment: Record<string, any>;
}





const removeAssignmentClick = () => emit('remove-click', props.assignment);
const restoreAssignmentClick = () => emit('restore-click', props.assignment);

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (!__props.assignment.mergeIsRequired)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!__props.assignment.deleted)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              "data-test-id": "remove-assignment-btn",
              disabled: __props.disabled,
              size: "small",
              onClick: removeAssignmentClick
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(DeleteOutlined))
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        (__props.assignment.deleted && !__props.assignment.previouslyDeleted)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 1,
              "data-test-id": "restore-assignment-btn",
              size: "small",
              onClick: restoreAssignmentClick
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(RollbackOutlined))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})